import { api } from './api';

/** The API half of onboarding: what the checklist needs to know. */
export interface ApiActivation {
  active_keys: number;
  test_keys: number;
  has_key: boolean;
  has_test_key: boolean;
  key_prefix: string | null;
  live_calls: number;
  test_calls: number;
  calls_total: number;
  first_call_done: boolean;
  first_call_at: string | null;
  last_call_at: string | null;
}

export interface OnboardingStatus {
  should_show_onboarding?: boolean;
  has_transactions?: boolean;
  transaction_count?: number;
  company_is_default?: boolean;
  company_missing_fields?: string[];
  company_has_tax_code?: boolean;
  company_id?: number | null;
  company_name?: string | null;
  api?: ApiActivation;
  reason?: string;
}

export const emptyActivation: ApiActivation = {
  active_keys: 0,
  test_keys: 0,
  has_key: false,
  has_test_key: false,
  key_prefix: null,
  live_calls: 0,
  test_calls: 0,
  calls_total: 0,
  first_call_done: false,
  first_call_at: null,
  last_call_at: null,
};

export const activationOf = (status: OnboardingStatus | null): ApiActivation => ({
  ...emptyActivation,
  ...(status?.api || {}),
});

export const onboardingService = {
  async status(): Promise<OnboardingStatus> {
    const { data } = await api.get('/api/v1/dashboard/onboarding-status');
    return data;
  },
};
